/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useLayoutEffect, useRef, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ClearIcon from "@mui/icons-material/Clear";
import useStyle from "./Styles";

interface Props {
  handleClick: () => void;
  error: string;
  setErrorHeight: any;
}

const ErrorBox: React.FC<Props> = ({ error, handleClick, setErrorHeight }) => {
  const { classes } = useStyle();

  const [errorBoxHeight, setErrorBoxHeight] = useState<number>(0);

  const errorBoxRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (errorBoxRef.current) {
      setErrorBoxHeight(errorBoxRef.current.offsetHeight);
    } else {
      setErrorBoxHeight(0);
    }
  }, [error]);

  useEffect(() => {
    if (errorBoxHeight) setErrorHeight(errorBoxHeight);
  }, [errorBoxHeight]);

  if (!error) return null;

  return (
    <Box ref={errorBoxRef} className={classes.pagesAddingErrorBox}>
      <Box className={classes.pagesErrorInternalTextBox}>
        <ErrorOutlineIcon />
        <Typography className={classes.errorTextStyle}>{error}</Typography>
      </Box>
      <ClearIcon className={classes.clearIconStyle} onClick={handleClick} />
    </Box>
  );
};

export default ErrorBox;
